import React from 'react';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import type { ButtonProps } from '../../components/Button';
import Button from '../../components/Button';
import { UIActions } from '../../ui/uiSlice';

interface RefetchMentionButtonProps {
  refetch: () => void;
  variant?: 'link' | 'secondary';
  size?: ButtonProps['size'];
}

const RefetchMentionButton = ({
  refetch,
  variant = 'link',
  size,
}: RefetchMentionButtonProps) => {
  const dispatch = useAppDispatch();

  return (
    <Button
      variant={variant}
      size={size}
      onClick={() => {
        refetch();
        dispatch(UIActions.clearToasts());
      }}
    >
      <strong>Try again</strong>
    </Button>
  );
};

export default RefetchMentionButton;
